<script>
  export let value;
</script>

<div class='live-inning'>
  {Math.floor(value.inning)} <span class='material-icons'> {value.inning % 1 === 0 ? 'expand_less' : 'expand_more'} </span>
</div>

<style>
  .live-inning {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 47.5px;
    height: 47.5px;

    font-family: var(--font-secondary-light);
    font-size: 28px;
  }
</style>
